import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=2d5d226a&scoped=true&"
import script from "./Snackbar.vue?vue&type=script&lang=js&"
export * from "./Snackbar.vue?vue&type=script&lang=js&"
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=2d5d226a&lang=scss&scoped=true&"
import style1 from "./Snackbar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d226a",
  null
  
)

export default component.exports